<template>
  <li
    :class="[
      'clearfix',
      'chat-message',
      isAuthenticatedUser(message.user) ? 'chat-message-mine' : 'chat-message-others'
    ]"
    :mine="isAuthenticatedUser(message.user)"
    :id="message.id"
    :msg_user="message.user?.id"
  >
    <div class="clearfix">
      <div class="header">
        <strong>
          {{ message.user ? message.user.name : 'Unknown User' }}
          <small class="ml-3"><i>{{ message.time }}</i></small>
        </strong>
      </div>
      <p v-html="renderMessage(message.message)" :class="isNewMessage(message) ? 'new-message' : ''"></p>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    auth_id: {
      type: Number,
      required: true
    },
    observer: {
      type: IntersectionObserver,
      required: true
    }
  },
  mounted() {
    this.observer.observe(this.$el);
  },
  methods: {
    isAuthenticatedUser(user) {
      return user && user.id === this.auth_id;
    },
    isNewMessage(message) {
      return !this.isAuthenticatedUser(message.user) && !message.read_at;
    },
    renderMessage(content) {
      if (!content) return 'Unknown Message';
      console.log('new msg');

      // Render file links: [File](https://example.com/file.pdf)
      content = content.replace(/\[File\]\((.*?)\)/g, '<a href="$1" target="_blank" class="file-link">📎 Download File</a>');

      // Optionally: convert line breaks to <br>
      return content.replace(/\n/g, '<br>');
    }
  }
};
</script>

<style scoped>
.chat-message {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  max-width: 75%;
  list-style: none;
}

.chat-message-mine {
  background-color: #28a745;
  text-align: right;
  color: white;
  margin-left: auto;
}

.chat-message-others {
  background-color: #bcbcbc;
  text-align: left;
  color: black;
  margin-right: auto;
  border: 1px solid #ddd;
}

.new-message {
  font-weight: bold;
}

.file-link {
  display: inline-block;
  margin-top: 5px;
  color: #007bff;
  text-decoration: underline;
}
</style>
